<template>
  <header>
    <div class="hero-article" data-aos="fade-up">
      <p class="hero-date">{{month}} {{year}}</p>
      <h2  class="hero-heading">New collection</h2>
      <p class="hero-text">Top Trends for you</p>
      <router-link :to="{name: 'AllItems'}">
        <base-button>View all items</base-button>
      </router-link>
      
    </div>
  </header>

</template>

<script>


export default {
  computed: {
    month() {
      return new Intl.DateTimeFormat("en-US", { month: "long" }).format(new Date());
    },
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
header {
  background: url("/public/images/hero.png");
  background-size: cover;
  background-repeat: no-repeat;
  height: 850px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.hero-article {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;
  margin-top: 100px;
}

.hero-date {
  color: rgba(255, 255, 255, 0.8);
  font-family: "Mabry Pro";
  font-size: 2.8rem;
  font-weight: 300;
}

.hero-heading {
  color: #fff;
  font-family: "Glusp";
  font-size: 5.8rem;
  font-weight: 700;
}

.hero-text {
  color: #fff;
  font-family: "Mabry Pro";
  font-size: 3.8rem;
  font-weight: 300;
  margin-bottom: 75px;
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  /* стили для мобильных устройств */
  .hero-date {
    font-size: 2rem;
  }
  .hero-heading {
    max-width: 43rem;
    font-size: 2.2rem;
    text-align: center;
  }
  .hero-text {
    font-size: 2.6rem;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  /* стили для планшетов */
  .hero-date {
    font-size: 2rem;
  }
  .hero-heading {
    max-width: 43rem;
    font-size: 3.2rem;
    text-align: center;
  }
  .hero-text {
    font-size: 2.6rem;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
  /* стили для ноутбуков */
  .hero-heading {
    text-align: center;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1200px) {
  /* стили для десктопов */
}
</style>